import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

export const CalendarSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'heromode',
})<{ heromode?: boolean }>(({ theme, heromode }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginLeft: 'auto',
  paddingRight: theme.spacing(1),
  ...(heromode
    ? {
        '& .MuiIconButton-root': { color: 'rgba(255,255,255,0.8)' },
        '& .MuiIconButton-root:hover': { backgroundColor: 'rgba(255,255,255,0.12)' },
      }
    : {}),
}));

export const CalendarDateButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'heromode',
})<{ component: string; heromode?: boolean }>(({ theme, heromode }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  border: heromode ? '1.5px solid rgba(255,255,255,0.3)' : 'none',
  backgroundColor: heromode ? 'rgba(255,255,255,0.15)' : 'transparent',
  cursor: 'pointer',
  borderRadius: theme.spacing(1),
  color: heromode ? '#fff' : theme.palette.text.primary,
  fontSize: '0.9rem',
  fontWeight: 500,
  padding: heromode ? '5px 12px' : undefined,
  '&:hover': {
    backgroundColor: heromode ? 'rgba(255,255,255,0.25)' : theme.palette.action.hover,
  },
}));

export const CalendarIcon = styled('span')({
  display: 'flex',
  alignItems: 'center',
});

export const CalendarPopoverContent = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const CompactCalendarPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: theme.spacing(1),
  },
}));

export const CompactCalendarContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const CompactCalendar = styled(Box)<{ startdate?: string; enddate?: string }>(
  ({ theme }) => ({
    '& .MuiPickersCalendarHeader-label': { fontSize: '0.85rem' },
    '& .MuiPickersDay-root': { fontSize: '0.85rem' },
    '& .MuiDateCalendar-root': { width: '100%', height: 'fit-content' },
    '& .MuiPickersDay-root.Mui-selected': { backgroundColor: theme.palette.primary.main },
    '& .MuiPickersDay-root[aria-selected="true"]': { backgroundColor: theme.palette.primary.main },
    '& .MuiDayCalendar-slideTransition': { minHeight: 250 },
    '& .MuiPickersSlideTransition-root': { minHeight: 250 },
  }),
);

export const DateShortcutsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
}));

export const DateShortcutButton = styled(Button)(({ theme }) => ({
  fontSize: '0.75rem',
  padding: theme.spacing(0.5, 1),
  minWidth: 'auto',
  height: 28,
  textTransform: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  backgroundColor: theme.palette.action.hover,
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

export const RangePickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'isselected' && prop !== 'isinrange',
})<{ isselected?: boolean; isinrange?: boolean }>(({ theme, isselected, isinrange }) => ({
  backgroundColor: isselected
    ? theme.palette.primary.main
    : isinrange
      ? theme.palette.primary.light
      : 'transparent',
  color: isselected || isinrange ? theme.palette.primary.contrastText : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: isselected
      ? theme.palette.primary.dark
      : isinrange
        ? theme.palette.primary.main
        : theme.palette.action.hover,
  },
}));
